<template>
  <section class="tf-card">
    <div class="tf-card__head">
      <span class="tf-card__icon"><i class="fa fa-exchange"></i></span>
      <div class="tf-card__titles">
        <h3 class="tf-card__title">Запросы к бэкенду</h3>
        <p class="tf-card__sub">Как долго отвечает API у настоящих посетителей и как часто ошибается</p>
      </div>
    </div>
    <div class="tf-card__body">
      <div v-if="!rows.length" class="an-empty">
        <i class="fa fa-exchange"></i>
        <span>За период замеров запросов нет</span>
      </div>
      <div v-else class="an-table-wrap">
        <table class="an-table">
          <thead>
          <tr>
            <th>Запрос</th>
            <th class="an-num">Запросов</th>
            <th class="an-num">Медиана</th>
            <th class="an-num">75%</th>
            <th class="an-num">95%</th>
            <th class="an-num">Ошибки</th>
            <th class="an-num" title="Браузер не сообщил статус: оборвалась сеть или старый браузер">Без статуса</th>
            <th>По странам, 75%</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in rows" :key="row.endpoint">
            <td><code>{{ row.endpoint }}</code></td>
            <td class="an-num">{{ formatCount(row.count) }}</td>
            <td class="an-num">{{ formatMs(row.p50) }}</td>
            <td class="an-num">{{ formatMs(row.p75) }}</td>
            <td class="an-num">{{ formatMs(row.p95) }}</td>
            <td class="an-num">
              <span :class="{ 'an-change an-change--worse': row.errorRate >= 0.05 }">{{ formatPercent(row.errorRate) }}</span>
            </td>
            <td class="an-num">{{ formatPercent(row.unknownRate) }}</td>
            <td>
              <span v-if="!row.byCountry || !row.byCountry.length" class="an-cell-sub">—</span>
              <span v-for="c in (row.byCountry || []).slice(0, 4)" :key="c.country" class="an-cell-sub">
                {{ countryLabel(c.country) }}: {{ formatMs(c.p75) }}
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import {formatMs, formatPercent, formatCount, countryLabel} from "@/common/rumFormat";

export default {
  name: "RumApi",
  props: {
    data: {type: Object, required: true},
  },
  computed: {
    rows() {
      return this.data.rows || []
    },
  },
  methods: {formatMs, formatPercent, formatCount, countryLabel},
}
</script>
